



































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { env } from '@/env';
import { DictionariesModel, DictionaryModel } from '@/models/dictionary.model';
const DictionaryStore = namespace('dictionaries');
const TranslateStore = namespace('translate');

@Component({
  name: 'AboutComponent'
})
export default class AboutComponent extends Vue {
  @DictionaryStore.Getter
  public getDictionaryLanguages!: DictionariesModel;

  @DictionaryStore.Action
  public fetchDictionaries!: () => Promise<any>;

  @TranslateStore.Getter
  public getResolvedLanguageName!: (abbr: string) => string;

  @TranslateStore.Action
  public fetchLanguages!: () => Promise<any>;

  private sgsDictionaryLanguages: Array<{
    sourceLanguage: string;
    targetLanguage: string;
    isBidirectional: boolean;
  }> = [];

  get version(): string {
    return env.appVersion ? env.appVersion : '';
  }

  get name(): string {
    return env.appName ? env.appName : '';
  }

  get build(): string {
    return env.appBuild ? env.appBuild : '';
  }

  private async mounted() {
    let dictionariesByLanguagePair = this.getDictionaryLanguages.dictionariesByLanguagePair as any;
    if (dictionariesByLanguagePair.length === 0) {
      await this.fetchDictionaries();
      await this.fetchLanguages();
    }
    dictionariesByLanguagePair = this.getDictionaryLanguages.dictionariesByLanguagePair as any;
    for (const key of Object.keys(dictionariesByLanguagePair)) {
      const dictionaries = dictionariesByLanguagePair[key] as (DictionaryModel[]);
      const sgsDictionary = dictionaries.filter((d) => d.workspaceName.toLowerCase().includes('sgs'))[0];
      if (sgsDictionary) {
        const simetricDictionary = this.sgsDictionaryLanguages.filter(
          (l) => l.sourceLanguage === sgsDictionary.targetLanguage && l.targetLanguage === sgsDictionary.sourceLanguage
        )[0];

        if (simetricDictionary) {
          simetricDictionary.isBidirectional = true;
        } else {
          this.sgsDictionaryLanguages.push({
            sourceLanguage: sgsDictionary.sourceLanguage,
            targetLanguage: sgsDictionary.targetLanguage,
            isBidirectional: false
          });
        }
      }
    }
  }

}
